import { Link } from 'react-router-dom'
import config from '../../config'
import { useTranslation } from '@/hooks/useTranslation'
import {
	LegalH3,
	LegalList,
	LegalP,
	LegalPageLayout,
	LegalSection,
	useLegalList,
	useLegalUpdatedDate,
} from '@/components/legal/LegalPageLayout'

const PrivacyPolicy = () => {
	const { t } = useTranslation()
	const date = useLegalUpdatedDate()
	const accountItems = useLegalList('privacy.accountItems')
	const widgetItems = useLegalList('privacy.widgetItems')
	const mentionItems = useLegalList('privacy.mentionItems')
	const autoItems = useLegalList('privacy.autoItems')
	const useItems = useLegalList('privacy.useItems')
	const basisItems = useLegalList('privacy.basisItems')
	const legalShareItems = useLegalList('privacy.legalShareItems')
	const retentionItems = useLegalList('privacy.retentionItems')
	const rightsItems = useLegalList('privacy.rightsItems')

	return (
		<LegalPageLayout
			title={t('privacy.privacyPolicy')}
			lastUpdated={t('legal.lastUpdated', { date })}
		>
			<LegalSection title={t('privacy.section1Title')}>
				<LegalP>
					{t('privacy.intro1', {
						appName: config.appName,
						companyName: config.companyName,
					})}
				</LegalP>
				<LegalP>{t('privacy.intro2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section2Title')}>
				<LegalH3>
					{t('privacy.section2_1Title', { appName: config.appName })}
				</LegalH3>
				<LegalP>{t('privacy.section2_1Intro')}</LegalP>
				<LegalList items={accountItems} />

				<LegalH3>{t('privacy.section2_2Title')}</LegalH3>
				<LegalP>{t('privacy.section2_2Intro')}</LegalP>
				<LegalList items={widgetItems} />

				<LegalH3>{t('privacy.section2_3Title')}</LegalH3>
				<LegalP>{t('privacy.section2_3Intro')}</LegalP>
				<LegalList items={mentionItems} />

				<LegalH3>{t('privacy.section2_4Title')}</LegalH3>
				<LegalP>{t('privacy.section2_4Intro')}</LegalP>
				<LegalList items={autoItems} />
			</LegalSection>

			<LegalSection title={t('privacy.section3Title')}>
				<LegalP>{t('privacy.section3Intro')}</LegalP>
				<LegalList items={useItems} />
			</LegalSection>

			<LegalSection title={t('privacy.section3bTitle')}>
				<LegalP>{t('privacy.section3bIntro')}</LegalP>
				<LegalList items={basisItems} />
			</LegalSection>

			<LegalSection title={t('privacy.section4Title')}>
				<LegalP>{t('privacy.section4Description')}</LegalP>

				<LegalH3>{t('privacy.section4_1Title')}</LegalH3>
				<LegalP>{t('privacy.section4_1Description')}</LegalP>

				<LegalH3>{t('privacy.section4_2Title')}</LegalH3>
				<LegalP>
					{t('privacy.section4_2Description', { appName: config.appName })}
				</LegalP>

				<LegalH3>{t('privacy.section4_3Title')}</LegalH3>
				<LegalP>{t('privacy.section4_3Intro')}</LegalP>
				<LegalP>{t('privacy.section4_3Footer')}</LegalP>

				<LegalH3>{t('privacy.section4_4Title')}</LegalH3>
				<LegalP>{t('privacy.section4_4Intro')}</LegalP>
				<LegalList items={legalShareItems} />

				<LegalH3>{t('privacy.section4_5Title')}</LegalH3>
				<LegalP>
					{t('privacy.section4_5Description', { appName: config.appName })}
				</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section5Title')}>
				<LegalP>{t('privacy.section5Intro')}</LegalP>
				<LegalList items={retentionItems} />
			</LegalSection>

			<LegalSection title={t('privacy.section6Title')}>
				<LegalP>{t('privacy.section6Content')}</LegalP>
				<LegalP>{t('privacy.section6Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section7Title')}>
				<LegalP>{t('privacy.section7Intro')}</LegalP>
				<LegalList items={rightsItems} />
				<LegalP>
					{t('privacy.section7Footer', { supportEmail: config.supportEmail })}
				</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section8Title')}>
				<LegalP>
					{t('privacy.section8Content', { supportEmail: config.supportEmail })}
				</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section9Title')}>
				<LegalP>
					{t('privacy.section9Content')}{' '}
					<Link
						to="/cookies"
						className="text-primary hover:text-primary/90 font-medium"
					>
						{t('privacy.cookiePolicyLink')}
					</Link>
					.
				</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section10Title')}>
				<LegalP>{t('privacy.section10Content')}</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section11Title')}>
				<LegalP>{t('privacy.section11Content')}</LegalP>
				<LegalP>{t('privacy.section11Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('privacy.section12Title')}>
				<LegalP>{t('privacy.contactDescription')}</LegalP>
				<p className="text-gray-600 mt-2">
					{config.companyName}
					<br />
					{config.companyAddress}
					<br />
					<a
						href={`mailto:${config.supportEmail}`}
						className="text-primary hover:text-primary/90 font-medium"
					>
						{config.supportEmail}
					</a>
				</p>
			</LegalSection>

		</LegalPageLayout>
	)
}

export default PrivacyPolicy
